import { render, staticRenderFns } from "./AppFormCard.vue?vue&type=template&id=6404ab1e"
import script from "./AppFormCard.vue?vue&type=script&lang=ts"
export * from "./AppFormCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports